export function toStringOrNull(s: any): string | null {
  return s && s?.toString().trim() != '' ? s?.toString().trim() : null
}

export function isNotNullOrEmptyString(s: any): boolean {
  return s && s?.toString().trim() != ''
}

export function isNullOrEmptyString(s: any): boolean {
  return !s || s?.toString().trim() == ''
}

export function toIntOrNull(x: any): number | null {
  return x && x?.toString().trim() != '' ? parseInt(x?.toString().trim()) : null
}

export function toFloatOrNull(x: any): number | null {
  return x && x?.toString().trim() != ''
    ? parseFloat(x?.toString().trim())
    : null
}

export function toTrimmedStringLowerCase(s: any): string {
  return s ? s?.toString().trim().toLowerCase() : ''
}

export function toTrimmedStringUpperCase(s: any): string {
  return s ? s?.toString().trim().toUpperCase() : ''
}

export function toTrimmedString(s: any): string {
  return s ? s?.toString().trim() : ''
}

export function toOnlyString(s: any): string {
  return s ? s?.toString() : ''
}

export function isNotNullOrUndefined(s: any): boolean {
  return s != null && s != undefined
}

export function isNullOrUndefined(s: any): boolean {
  return s == null || s == undefined
}
